export enum InvoiceDiscountType {
  Percent = 'percent',
  Amount = 'amount',
}
